import React, { useState, useMemo } from "react";
import {
  Box,
  Flex,
  Heading,
  InputGroup,
  InputRightElement,
  Input,
  IconButton,
  Button,
  useBreakpointValue,
  Wrap,
  WrapItem,
  Menu,
  MenuButton,
  MenuList,
  MenuItem
} from "@chakra-ui/react";
import { SearchIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { useMeetingContext } from "./MeetingContext";

const MeetingHeader: React.FC = () => {
  const { meetings, searchTerm, setSearchTerm, activeFilter, setActiveFilter } = useMeetingContext();
  const [selectedFilter, setSelectedFilter] = useState<string | null>("recent");
  const [selectedProject, setSelectedProject] = useState("All Projects");
  
  // Extract all unique projects from meetings data
  const availableProjects = useMemo(() => {
    const projectsSet = new Set<string>();
    meetings.forEach(meeting => {
      projectsSet.add(meeting.project);
    });
    return Array.from(projectsSet).sort();
  }, [meetings]);
  
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Already using real-time search, so no additional action needed
  };
  
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterClick = (filter: string | null) => {
    // If selecting a filter other than project, reset selectedProject
    if (filter !== "project" && selectedProject !== "All Projects") {
      setSelectedProject("All Projects");
    }
    
    if (selectedFilter === filter) {
      setSelectedFilter(filter);
      setActiveFilter(filter as any);
    } else {
      setSelectedFilter(filter);
      setActiveFilter(filter as any);
    }
  };
  
  const handleProjectSelect = (project: string) => {
    setSelectedProject(project);
    
    if (project === "All Projects") {
      // If "All Projects" selected, clear the project filter and search term
      setSelectedFilter(null);
      setActiveFilter(null);
      // Only clear the search if it was being used for project filtering
      if (activeFilter === "project") {
        setSearchTerm("");
      }
    } else {
      // Apply project filter without affecting the search term
      setSelectedFilter("project");
      setActiveFilter("project");
      
      // Use a custom event to communicate the selected project without changing the search term
      const event = new CustomEvent("projectSelected", { detail: project });
      document.dispatchEvent(event);
    }
  };

  // Listen for project selection events
  React.useEffect(() => {
    const handleProjectSelected = (e: any) => {
      // This function is called when a project is selected, but we don't update searchTerm here
      // The filtering logic will be handled in MeetingContext.tsx
    };
    
    document.addEventListener("projectSelected", handleProjectSelected);
    
    return () => {
      document.removeEventListener("projectSelected", handleProjectSelected);
    };
  }, []);

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box>
      <Flex 
        justifyContent="space-between" 
        alignItems="center" 
        mb={6}
      >
        <Heading
          fontSize="30px"
          fontWeight="bold"
          color="gray.800"
        >
          MEETINGS
        </Heading>
        <Flex align="center">
          {/* <Menu>
            <MenuButton 
              as={Button} 
              rightIcon={<ChevronDownIcon />}
              bg="white"
              borderWidth="1px"
              borderColor="gray.200"
              _hover={{ bg: "gray.50" }}
              _active={{ bg: "gray.50" }}
              // _hover={{ bg: selectedFilter === "project" ? "blue.800" : "gray.50" }}
              // _active={{ bg: selectedFilter === "project" ? "blue.800" : "gray.50" }}
              mr={3}
              width="170px"
              textAlign="left"
              fontSize="sm"
            >
              {selectedProject}
            </MenuButton>
            <MenuList maxH="300px" overflowY="auto">
              <MenuItem onClick={() => handleProjectSelect("All Projects")}>
                All Projects
              </MenuItem>
              {availableProjects.map((project, index) => (
                <MenuItem key={index} onClick={() => handleProjectSelect(project)}>
                  {project}
                </MenuItem>
              ))}
            </MenuList>
          </Menu> */}
          <form onSubmit={handleSearch}>
            <InputGroup size="md" width="280px">
          <Input
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearchChange}
                borderRightRadius="0"
                _focus={{
                  borderColor: "purple.600",
                  boxShadow: "none",
                }}
          />
              <InputRightElement width="48px">
                <IconButton
                  aria-label="Search"
                  icon={<SearchIcon />}
                  size="sm"
                  type="submit"
                  colorScheme="purple"
                  borderLeftRadius="0"
                  width="100%"
                  height="38px"
                />
            </InputRightElement>
        </InputGroup>
          </form>
        </Flex>
      </Flex>

      <Wrap spacing={2} mb={6}>
        <WrapItem>
        <Button 
          size="sm"
            borderRadius="md"
          px={4}
            py={1}
            bg={selectedFilter === "salesExecutive" ? "blue.700" : "gray.100"}
            color={selectedFilter === "salesExecutive" ? "white" : "gray.800"}
            _hover={{ bg: selectedFilter === "salesExecutive" ? "blue.800" : "gray.200" }}
            onClick={() => handleFilterClick("salesExecutive")}
        >
          Sales Executive's Name
          </Button>
        </WrapItem>
        <WrapItem>
        <Button 
          size="sm"
            borderRadius="md"
          px={4}
            py={1}
            bg={selectedFilter === "client" ? "blue.700" : "gray.100"}
            color={selectedFilter === "client" ? "white" : "gray.800"}
            _hover={{ bg: selectedFilter === "client" ? "blue.800" : "gray.200" }}
            onClick={() => handleFilterClick("client")}
        >
          Client's Name
        </Button>
        </WrapItem>
        <WrapItem>
        <Button 
          size="sm"
            borderRadius="md"
          px={4}
            py={1}
            bg={selectedFilter === "recent" ? "blue.700" : "gray.100"}
            color={selectedFilter === "recent" ? "white" : "gray.800"}
            _hover={{ bg: selectedFilter === "recent" ? "blue.800" : "gray.200" }}
            onClick={() => handleFilterClick("recent")}
        >
          Recent First
        </Button>
        </WrapItem>
      </Wrap>
          </Box>
  );
};

export default MeetingHeader;
